/* FarmPacks colour preference: shared by every header, including editor reloads. */
(() => {
  const root = document.documentElement;
  const key = 'farmpacks-theme';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let transition;
  let selectedTheme = root.dataset.theme === 'dark' ? 'dark' : 'light';

  function syncButtons() {
    const light = root.dataset.theme === 'light';
    document.querySelectorAll('[data-fp-theme-toggle]').forEach((button) => {
      button.setAttribute('aria-label', light ? 'Switch to dark theme' : 'Switch to light theme');
      button.setAttribute('title', light ? 'Switch to dark theme' : 'Switch to light theme');
      button.hidden = false;
    });
  }

  function apply(theme, animate = false) {
    selectedTheme = theme;
    const update = () => {
      root.dataset.theme = selectedTheme;
      syncButtons();
    };
    transition?.skipTransition();
    if (animate && !reducedMotion.matches && document.startViewTransition) {
      // A short cross-fade also covers gradients and app-rendered surfaces.
      // It does not change slideshow, reveal, or hover transition timings.
      root.classList.add('fp-theme-changing');
      transition = document.startViewTransition(update);
      const current = transition;
      current.finished.catch(() => {}).finally(() => {
        if (transition === current) {
          root.classList.remove('fp-theme-changing');
          transition = undefined;
        }
      });
    } else if (animate && !reducedMotion.matches) {
      // Fallback path. The colour transition only exists while this class is
      // on <html>, so the rest of the time no element carries a standing
      // background-color transition for the browser to keep book on.
      root.classList.add('fp-colour-anim');
      window.setTimeout(() => root.classList.remove('fp-colour-anim'), 400);
      update();
    } else {
      update();
    }
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('[data-fp-theme-toggle]')) return;
    const theme = selectedTheme === 'light' ? 'dark' : 'light';
    try { localStorage.setItem(key, theme); } catch (error) { /* Still works for this page. */ }
    apply(theme, true);
  });
  window.addEventListener('storage', (event) => {
    if (event.key === key || event.key === null) apply(event.newValue === 'dark' ? 'dark' : 'light');
  });
  window.addEventListener('pageshow', () => {
    try { apply(localStorage.getItem(key) === 'dark' ? 'dark' : 'light'); }
    catch (error) { syncButtons(); }
  });
  document.addEventListener('shopify:section:load', syncButtons);
  syncButtons();
})();
